<template>
  <div class="content-header-time-buttons">
    <button
      v-for="button in buttons"
      :key="button.id"
      :class="['header-time-buttons', { selected: selectedButtonId === button.id }]"
      @click="handleButtonClick(button.id)"
    >
      {{ button.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    selectedButtonId: {
      type: Number,
      required: false,
      default: null,
    },
    handleButtonClick: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.content-header-time-buttons {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 350px;
  padding: 5px 10px;
  border-radius: 12px;
  background: #e6e9eb;
}
.header-time-buttons {
  background: #e6e9eb;
  border-radius: 12px;
  width: 140px;
  height: 48px;
  font-weight: 600;
  font-size: 1rem;
  color: #37434a;
  padding: 0px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}
.header-time-buttons:hover,
.header-time-buttons.selected {
  background: white;
  color: #202a2f;
}
.header-time-buttons:not(:first-child) {
  margin-left: 10px;
}
</style>
